var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedfiledata",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_tracked_files: null,

	_who: null,
});

function init() {
	this._tracked_files = {};
	this.push({});
}

function uninit() {
	this._core_forms = null;
	this._current_form = "";
}

function triggers() {
	return {
		add: add,
		view: view,
		reset: reset
	};
}

function view(data) {
	var who = data.who;
	var group = data.group;

	if (who === this._who) return;

	this._who = who;
	this._group = group;
	this._tracked_files = {};
	this.push({});
}

function reset() {
	this.emit("usermetrics:trigger:track", "close managed file data", {
		who: this._who
	});
	this._who = null;
	this._group = null;
	this.push({});
}

function add(data) {
	var file = data.file;

	if (this._tracked_files[file]) return;
	this._tracked_files[file] = true;

	this.api.manage.file
		.data(this._who, file, this._group)
		.then(handle_file_data.bind(this));
	this.emit("usermetrics:trigger:track", "add managed file data", {
		who: this._who,
		file: file
	});
}

function handle_file_data(data) {
	var update = {};
	update[data._id] = data;
	this.extend(update);
}
